export enum PBtnTagColor {
  PRIMARY = 'primary',
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  WARNING = 'warning',
  INFO = 'info',
  GREY = 'grey',
}
